import React from "react";
import useClickOutside from '../../hooks/useClickOutside';
import { useRef } from 'react';
import { Modal } from "../Modal";
import { ConnectWallet } from "../ConnectWallet";
import PropTypes from "prop-types";
export function ConnectWalletModal(_a) {
    var close = _a.close, loginMetamask = _a.loginMetamask, loginWalletConnect = _a.loginWalletConnect, isOpen = _a.isOpen;
    var ref = useRef(null);
    useClickOutside(ref, close, isOpen);
    return (React.createElement(Modal, { close: close, passRef: ref },
        React.createElement(ConnectWallet, { loginMetamask: loginMetamask, loginWalletConnect: loginWalletConnect })));
}
ConnectWalletModal.propTypes = {
    close: PropTypes.func,
    loginMetamask: PropTypes.func,
    loginWalletConnect: PropTypes.func,
    isOpen: PropTypes.bool,
};
//# sourceMappingURL=ConnectWalletModal.js.map